export const DEFAULT_STORAGE_ROOT = 'finnaircom';
